<template>
  <div class="coupon_list">
    <loader style="height: 80vh" v-if="coupons.length === 0"/>

    <coupon
      v-for="(coupon) in coupons"
      :key="coupon.id || coupon.title"
      class="my2"
      :coupon="coupon"
      :show-stats="showStats"
      :device-token="deviceToken"
    />
  </div>
</template>

<script>
import CarouselMixin from '@/mixins/carousel_mixin';
import Coupon from './Coupon.vue';

export default {
  name: 'coupon-list',
  components: { Coupon },
  mixins: [CarouselMixin],

  props: {
    coupons: Array,
    deviceToken: { type: String, required: false, default: null },
    showStats: { type: Boolean, required: false, default: false },
  },
};
</script>

<style lang="scss" scoped>
  .coupon_list {
    display: flex;
    flex-direction: column;
    max-width: $app_screen_width;
  }
</style>
